import { render } from "./UserlogDetails.vue?vue&type=template&id=6fdb05cb"
import script from "./UserlogDetails.vue?vue&type=script&lang=js"
export * from "./UserlogDetails.vue?vue&type=script&lang=js"

import "./UserlogDetails.vue?vue&type=style&index=0&id=6fdb05cb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__